import React from 'react';

import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';

const FieldErrorPopup = (props) => {
    const getText = (text) => {
        if (Array.isArray(text)) {
            return (
                <>
                    {text.map((t, index) => (
                        <p key={`errorLine_${index}`}>{t}</p>
                    ))}
                </>
            );
        } else {
            return <div>{text}</div>;
        }
    };

    return (
        <SimplePopup text={getText(props.text)} popupRef={props.popupRef}>
            {props.children}
        </SimplePopup>
    );
};
export default FieldErrorPopup;
